import { Component, OnInit, Input } from '@angular/core';
import { ModalController, NavParams} from '@ionic/angular';
import { NgForm } from '@angular/forms';
import moment from 'src/app/utils/moment';
import { HelperService, OrganizationService } from 'src/app/services';
import { WorkoutProgram } from 'src/app/models/training/workout-program.model';

@Component({
  selector: 'app-workout-program-settings',
  templateUrl: './workout-program-settings.page.html',
  styleUrls: ['./workout-program-settings.page.scss'],
})
export class WorkoutProgramSettingsPage implements OnInit {

  public action: "add" | "edit";
  public dates: {start: Date, end: Date};
  public endPickerStartAt: Date = (moment as any)().startOf("day").toDate();
  public form: any;
  public isFormSubmitted: boolean;
  public maxDate = (moment as any)().add(1, "year").endOf("year").toISOString();
  public type: "user" | "library";
  public workoutProgram: Partial<WorkoutProgram>;
  private defaultEndHour = 0;
  private endDateTouched = false;  

  @Input() mode: "program" | "template" | "workout";
  @Input() template: any;
  @Input() premium = false;
  @Input() programGoals: any;


  constructor(
    private helperService: HelperService,
    private modalCtrl: ModalController,
    private navParams: NavParams,
    private organizationService: OrganizationService
  ) {
    this.type = this.navParams.get("type");
    this.action = this.navParams.get("action");
    this.workoutProgram = this.navParams.get("workoutProgram");
    this.workoutProgram.workouts = this.workoutProgram.workouts || [];
    this.dates = {
      start: new Date(this.workoutProgram.startDate),
      end: this.workoutProgram.endDate? new Date(this.workoutProgram.endDate) : null
    };

    const programSettings = this.organizationService.getAppOrganization()?.getSetting("programs");
    const orgDefaultStartTime: string | null = programSettings?.defaultStartTime || null;
    const orgDefaultEndTime: string | null = programSettings?.defaultEndTime || null;
    this.defaultEndHour = this.parseHour(orgDefaultEndTime);
    this.endDateTouched = !!this.dates.end;

    if (this.action === "add" && orgDefaultStartTime) {
      const [hourStr] = orgDefaultStartTime.split(":");
      const hour = parseInt(hourStr, 10);
      if (!Number.isNaN(hour)) {
        const startMoment = (moment as any)(this.dates.start).hour(hour).minute(0).second(0).millisecond(0);
        this.dates.start = startMoment.toDate();
      }
    }

    if (this.action === "add" && this.dates.end && orgDefaultEndTime) {
      const [hourStr] = orgDefaultEndTime.split(":");
      const hour = parseInt(hourStr, 10);
      if (!Number.isNaN(hour)) {
        this.dates.end = (moment as any)(this.dates.end).hour(hour).minute(0).second(0).millisecond(0).toDate();
      }
    }

    const endStart = this.dates.end ? (moment as any)(this.dates.end) : (moment as any)().startOf("day");
    if (!this.dates.end && orgDefaultEndTime) {
      const [hourStr] = orgDefaultEndTime.split(":");
      const hour = parseInt(hourStr, 10);
      if (!Number.isNaN(hour)) {
        endStart.hour(hour).minute(0).second(0).millisecond(0);
      }
    }
    this.endPickerStartAt = this.dates.end || endStart.toDate();
  }

  ngOnInit() {
  }

  endDateChanged(value: Date) {
    this.dates.end = this.normalizeNewEndDate(value);
  }

  private parseHour(timeStr: string | null): number {
    if (!timeStr) {
      return 0;
    }
    const hour = parseInt(timeStr.split(":")[0], 10);
    return Number.isNaN(hour) ? 0 : hour;
  }

  private normalizeNewEndDate(value: Date): Date {
    if (!value) {
      this.endDateTouched = false;
      return null;
    }
    const next = (moment as any)(value);
    if (!this.endDateTouched && next.hour() === (moment as any)().hour()) {
      next.hour(this.defaultEndHour).minute(0).second(0).millisecond(0);
    }
    this.endDateTouched = true;
    return next.toDate();
  }

  onSubmit(formData: NgForm) {
    this.isFormSubmitted = true;
    if(!formData.valid) {
      return
    }
    
    if(this.mode === "program") {
      this.workoutProgram.startDate = this.dates.start.toISOString();
      this.workoutProgram.endDate = this.dates.end? this.dates.end.toISOString() : null;
    }

    this.modalCtrl.dismiss({ 
      status: "submitted",
      data: this.workoutProgram 
    });
  }

  getCounter(data: string, maxLength: number) {
    return `${data? maxLength - data.length : maxLength} /  ${maxLength}`
  }

  cancel() {
    this.modalCtrl.dismiss({ status: "canceled" });
  }
}
